import * as Schema from "effect/Schema";
export class TextGenerationError extends Schema.TaggedError()("TextGenerationError", {
    operation: Schema.String,
    detail: Schema.String,
    cause: Schema.optional(Schema.Defect()),
}) {
    get message() {
        return `Text generation failed in ${this.operation}: ${this.detail}`;
    }
}
